import { Component, Input } from "@angular/core";

@Component({
  selector: "app-card-summary",
  templateUrl: "./card-summary.component.html",
  styleUrls: ["./card-summary.component.scss"],
})

/**
 * Card Summary Component
 * Reusable card component for displaying summary information with optional icon
 */
export class CardSummaryComponent {
  @Input() title: string = "";

  @Input() value: string | number | null = "";

  @Input() subtitle: string | number | null = "";

  @Input() icon: string | undefined;

  @Input() iconColor: string = "primary";
}
